export enum SSOProvider {
  punchh,
  paytronix,
  personica,
  spendgo
}
